// extracted by mini-css-extract-plugin
export default {"layout":"LayoutUI_layout__oQjxp","dark":"LayoutUI_dark__JXcLO"};